import { createFileRoute } from "@tanstack/react-router";
import { PayPage } from "@/components/pay/PayPage";

export const Route = createFileRoute("/pay/$storeId")({
  component: PayPage,
});
